import React, {useContext} from 'react'
import useTranslate from "../../../../modules/local/useTranslate";
import classNames from "classnames";
import getTitle from "../../../../helpers/getTitle";
import {Image} from "antd";
import {ImagePlaceholder} from "../../../../conts/imageBase64";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {DetailModalContent} from "../../../AppLocals/Church/components/ChurchForm";
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";

export const UserCheckinCardItem = ({item, onClick, Wrapper = 'div', className}) => {
    const t = useTranslate()
    const {owner, checkin_time, status} = item ?? {}
    const place_name = getTitle(item?.owner) || item?.name;
    const user = getTitle(item?.user)
    const {isLg} = useContext(LayoutContext)

    return (
        <Wrapper
            className={classNames("flex flex-center rounded-lg relative", className)}>
            <div className="flex flex-col lg:flex-row items-start rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition p-3 gap-3 w-full">
                {/* Avatar / Image */}
                <Image
                    src={owner?.photo || ImagePlaceholder}
                    fallback={ImagePlaceholder}
                    style={{width: isLg ? 160 : "100%", height: 100}}
                    className="object-cover rounded-lg bg-gray-100"
                    wrapperStyle={{width: isLg ? 160 : "100%"}}
                    wrapperClassName="rounded-lg flex-shrink-0"
                    preview={false}
                />

                {/* Nội dung */}
                <div className="flex flex-col justify-center flex-1 gap-2">
                    {/* Nội dung text */}
                    <div className="text-sm sm:text-base text-color-300 italic leading-snug tracking-wider">
                        {t(
                            '{user} at {place_name}, {at}',
                            {
                                user: <span className="font-bold text-primary-700">{user}</span>,
                                place_name: <DrawDialog
                                    width={600}
                                    title={
                                        <div
                                            className="text-center font-bold text-base text-color-000 leading-snug no-underline max-lines-1">
                                            {place_name}
                                        </div>
                                    }
                                    closable={false}
                                    component={
                                        <span className="font-semibold text-green-600">{place_name}</span>
                                    }>
                                    {(isToggle, toggle) => isToggle && (
                                        <DetailModalContent
                                            item={owner}
                                            reportAccess={false}
                                        />
                                    )}
                                </DrawDialog>,
                                at: (
                                    <time className="font-medium text-sm text-color-100">
                                        {formatSimplifyDate(checkin_time, 'fullTime')}
                                    </time>
                                ),
                            }
                        )}
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}
